function setupTimelineList(host, opts) {
  const list = host.querySelector('.w-timeline__list');
  if (!list) return null;
  const rail = list.querySelector('.w-timeline__rail');
  const fill = list.querySelector('.w-timeline__rail-fill');
  const items = Array.from(list.querySelectorAll('.w-timeline__item'));
  const dots = items.map((item) => item.querySelector('.w-timeline__dot'));
  const toggles = Array.from(list.querySelectorAll('.w-timeline__toggle'));
  const panels = Array.from(list.querySelectorAll('.w-timeline__panel'));
  if (items.length === 0) return null;

  const { signal } = opts;
  const mode = opts.mode || 'scroll';
  const scrollRoot = opts.scrollRoot || window;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let raf = null;

  let staticIndex = opts.currentIndex;
  if (mode === 'static' && staticIndex == null) {
    staticIndex = 0;
    items.forEach((item, index) => {
      if (item.querySelector('.w-timeline__text.is-open')) staticIndex = index;
    });
  }

  const centerY = () => {
    if (scrollRoot === window) return window.innerHeight * 0.5;
    const rect = scrollRoot.getBoundingClientRect();
    return rect.top + scrollRoot.clientHeight * 0.75;
  };

  const update = () => {
    if (dots.length === 0) return;
    const listTop = list.getBoundingClientRect().top;
    const centers = dots.map((dot) => {
      const rect = dot.getBoundingClientRect();
      return rect.top + rect.height / 2 - listTop;
    });
    const first = centers[0];
    const last = centers[centers.length - 1];

    if (rail) {
      rail.style.top = first + 'px';
      rail.style.height = Math.max(0, last - first) + 'px';
    }

    let progress;
    if (mode === 'static') {
      const ci = Math.max(0, Math.min(staticIndex || 0, centers.length - 1));
      progress = centers[ci];
      if (ci < centers.length - 1) progress += (centers[ci + 1] - centers[ci]) * 0.5;
    } else if (reduceMotion) {
      progress = last;
    } else {
      progress = centerY() - listTop;
      progress = Math.max(first, Math.min(progress, last));
    }

    if (fill) {
      fill.style.top = first + 'px';
      fill.style.height = Math.max(0, progress - first) + 'px';
    }

    items.forEach((item, index) => {
      item.classList.toggle('is-future', centers[index] > progress + 0.5);
    });
  };

  const onScroll = () => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = null;
      update();
    });
  };

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const text = toggle.closest('.w-timeline__text');
      if (!text) return;
      const open = text.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      const panel = text.querySelector('.w-timeline__panel');
      if (panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      update();
    }, { signal });
  });

  panels.forEach((panel) => {
    panel.addEventListener('transitionend', update, { signal });
  });

  window.addEventListener('resize', update, { signal });
  if (mode === 'scroll' && !reduceMotion) {
    scrollRoot.addEventListener('scroll', onScroll, { signal, passive: true });
  }
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => {
      if (!signal.aborted) update();
    });
  }

  update();
  return { update };
}

class WTimeline extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.list = setupTimelineList(this, { signal: this.controller.signal, mode: 'scroll' });
    if (!this.list) return;
    requestAnimationFrame(() => {
      if (!this.controller.signal.aborted) this.classList.add('is-ready');
    });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

customElements.define('w-timeline', WTimeline);

if (!window.__wTimelineDrawerInit) {
  window.__wTimelineDrawerInit = true;
  document.addEventListener('w-drawer:open', (event) => {
    const drawer = event.target;
    if (!drawer || !drawer.querySelector('.w-timeline__list')) return;
    if (!drawer.__wTimelineList) {
      drawer.__wTimelineController = new AbortController();
      drawer.__wTimelineList = setupTimelineList(drawer, {
        signal: drawer.__wTimelineController.signal,
        mode: 'scroll',
        scrollRoot: drawer.querySelector('.w-drawer__body'),
      });
    }
    const list = drawer.__wTimelineList;
    if (list) {
      list.update();
      setTimeout(() => list.update(), 350);
    }
  });
}
